<!-- verify page -->

<template>
    <div class='verify_content_box'>
        <div class="container">
            <div class="tt_box">Product Verification</div>
            <div class="desc_box">Please Enter The Product Code</div>
            <div class="code_out_box">
                <img src="@/assets/images1/59.png" alt="" class="code">
                <p class="num">9876899768</p>
            </div>
            <div class="ipt_out_box">
                <input type="text" v-model="code" placeholder="Please Enter" :disabled="loading">
                <el-button :loading="loading" class="btn" type="primary" @click="submit">Confirm</el-button>
            </div>
        </div>

        <!-- fail提示 -->
        <el-dialog title=" " :visible.sync="isShowFail" width="600px">
            <div class="error_content_box">
                <img src="@/assets/images1/60.png" alt="" class="icon">
                <div class="tt_box">verification failed</div>
                <div class="desc_box">Sorry, The System Cannot Find Product Information</div>
            </div>
        </el-dialog>

        <!-- succeed提示 -->
        <el-dialog title=" " :visible.sync="isShowSuccess" width="600px">
            <div class="error_content_box">
                <img src="@/assets/images1/61.png" alt="" class="icon">
                <div class="tt_box">Verified</div>
                <div class="desc_box">The product is in working order</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            code: "",
            loading: false,
            isShowFail: false,
            isShowSuccess: false
        }
    },
    mounted() {
    },
    methods: {
        async submit() {
            if (this.loading) return;
            if (!this.code) return this.$msg("Please enter the verification code", "e")
            this.loading = true;
            // axios.post('https://api.ldtech.com/api/VerificationCode/VerifyCode', JSON.stringify({
            //     VerificationCode: 123456789000000001
            // })).then(
            //     reponse => {
            //         console.log("请求数据succeed了:", reponse.data)
            //     },
            //     error => {
            //         console.log("请求数据fail了:", error.message)
            //     }
            // )
            // "123456789000000001"
            const response = await fetch('https://api.ldtech.com/api/VerificationCode/VerifyCode', {
                method: 'POST',
                body: JSON.stringify({ VerificationCode: this.code }),
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: "same-origin"
            });
            const myJson = await response.json();
            console.warn(myJson);
            if (myJson.Success) {
                this.loading = false;
                this.code = "";
                this.isShowSuccess = true;
            } else {
                this.loading = false;
                this.code = "";
                this.isShowFail = true;
            }
        }
    },
}
</script>

<style lang='scss' scoped>
.container {
    margin: 108px auto;
    text-align: center;

    .tt_box {
        font-size: 32px;
        font-family: Poppins, Poppins-700;
        font-weight: 700;
        text-align: CENTER;
    }

    .desc_box {
        margin-top: 12px;
        font-size: 16px;
        font-family: Inter, Inter-500;
        font-weight: 500;
        text-align: CENTER;
    }

    .code_out_box {
        width: 265px;
        height: 265px;
        margin: 32px auto 0;
        background: url(~@/assets/images1/58.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        box-sizing: border-box;
        padding: 44px 0 0;

        .code {
            width: 126px;
            height: 126px;
        }

        .num {
            font-size: 16px;
            font-family: Inter, Inter-500;
            font-weight: 500;
            text-align: CENTER;
            color: #000000;
            line-height: 19px;
            margin-top: 4px;
        }
    }

    .ipt_out_box {
        margin-top: 32px;
        display: flex;
        align-items: center;
        justify-content: center;

        input {
            width: 405px;
            height: 43px;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid #fa14d5;
            border-radius: 4px;
            padding: 12px;
            font-size: 16px;
            font-family: Inter, Inter-500;
            font-weight: 500;
            text-align: LEFT;
            color: #12181d;
            line-height: 1.5;
            box-sizing: border-box;
            outline: none;
        }

        .btn {
            display: block;
            margin-left: 24px;
            width: 110px;
            height: 43px;
            background: #f624d5 linear-gradient(90deg, #f624d5, #3437f7 100%);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-family: Inter, Inter-500;
            font-weight: 500;
            text-align: CENTER;
            color: #ffffff;
            border: none;
            outline: none;
            color: #fff;
        }
    }
}

.error_content_box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px 0 50px;

    .icon {
        width: 65px;
        height: 65px;
    }

    .tt_box {
        margin-top: 24px;
        font-size: 32px;
        font-family: cfont1;
        font-weight: 700;
        text-align: CENTER;
        color: #12181d;
    }

    .desc_box {
        font-size: 16px;
        font-family: Inter, Inter-500;
        font-weight: 500;
        text-align: CENTER;
        color: #8fa2b2;
        line-height: 19px;
        margin-top: 24px;
    }
}

::v-deep .el-dialog {
    border-radius: 16px !important;
}
</style>